<template>

    <div class="find-store-list single-product__size-guide alt-guide-chain" v-if="findStore.stores.length">
        <div class="single-product__size-guide-container">
        <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.026 0.619385C4.31562 0.623391 2.02529 3.08149 2.02529 5.98933C2.02529 7.81538 2.96342 9.5092 4.00057 10.8314C2.44735 11.0768 2.13048e-07 11.6898 2.13048e-07 13.1152C-0.00099993 14.759 3.5195 15.6194 6.999 15.6194C10.4785 15.6194 14 14.7579 14 13.1152C14 11.6908 11.5527 11.0788 10.0054 10.8334C11.0616 9.45211 12.0267 7.64109 12.0267 5.61471C12.0267 4.25444 11.5166 2.99434 10.5895 2.0668C9.65538 1.13224 8.3932 0.619385 7.03401 0.619385H7.026ZM7.026 1.62306H7.03401C8.12516 1.62306 9.13731 2.03374 9.88241 2.77698C10.6205 3.51521 11.0266 4.52189 11.0266 5.61371C11.0266 8.88316 7.99914 11.6818 7.026 12.4962C6.04986 11.6898 3.02543 8.95127 3.02543 5.99134C3.02543 3.6264 4.85669 1.62606 7.026 1.62306ZM6.94399 3.62239C6.41433 3.64453 5.91502 3.87604 5.55546 4.26618C5.1959 4.65633 5.00541 5.17331 5.02572 5.70386C5.04808 6.2346 5.27959 6.73483 5.66952 7.09494C6.05945 7.45505 6.57601 7.64568 7.10602 7.62506C7.63577 7.60318 8.13524 7.37175 8.49485 6.98155C8.85447 6.59134 9.04487 6.07421 9.02429 5.54359C9.00038 5.0134 8.7684 4.51411 8.37882 4.15432C7.98924 3.79454 7.47358 3.60337 6.94399 3.62239ZM6.985 4.62206H7.026C7.29126 4.61674 7.54776 4.71718 7.73907 4.90127C7.93039 5.08536 8.04084 5.33803 8.04615 5.60369C8.05146 5.86935 7.95117 6.12624 7.76736 6.31785C7.58355 6.50945 7.33126 6.62008 7.06601 6.62539C6.54994 6.64743 6.04786 6.21671 6.02586 5.66379C6.01557 5.39822 6.11088 5.1394 6.29087 4.94411C6.47087 4.74881 6.71985 4.633 6.985 4.62206ZM4.77168 11.7439C5.37256 12.3967 6.02767 12.9972 6.72996 13.5389L7.026 13.7623L7.32605 13.5389C7.40706 13.4788 8.28018 12.8177 9.25132 11.7459C11.8557 12.0514 13.0019 12.7907 13.0019 13.1162C13.0019 13.6471 10.7235 14.6187 7.001 14.6187C3.27847 14.6187 1.00014 13.6471 1.00014 13.1162C0.999143 12.7897 2.15031 12.0484 4.77168 11.7439Z" fill="#231F20"/>
            </svg>

            <span><a class="single-product__size-guide--btn" @click="show_guide__popup">Find In Stores</a></span>
            
        </div>
        <div class="size-guide__popup" ref="popupRef" id="size-guide__popup-2" :class="open ? 'active' : ''">
            <div class="find-store-list__content size-guide__content" ref="contentRef">
                
                 <span class="size-guide__close-btn" @click="close_guide__popup">
                    <svg class="icon_close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M6.4 19L5 17.6l5.6-5.6L5 6.4L6.4 5l5.6 5.6L17.6 5L19 6.4L13.4 12l5.6 5.6l-1.4 1.4l-5.6-5.6z"/></svg>
                </span>
                    <h4 class="size-guide__heading">Available In Stores</h4>
                    <div class="find-store__product">

                        <p v-html="htmlSpecialcharsDecode(productName)"></p>

                        <p>SKU: {{ productSKU }}</p>
                    </div>
                    <div class="size-guide__tab-content active-tab" >
                        <div
                            class="find-store__item"
                            v-for="(store, index) in findStore.stores"
                            :key="store.holder_code"
                            :id="`store_list${index}`"
                            :class="{ active: storeItemActive.has(index) }"
                        >
                            <div class="find-store__item-heading" 
                             @click="showFaqItemContent(index)"
                            >
                                <h5 v-html="store.store_detail.name.replace(/\\'/g, `'`)"></h5>
                                <div class="close-expand-item">
                                    <span class="expand-item"></span>
                                    <span class="close-item"></span>
                                </div>
                            </div>

                            <div
                                class="find-store__item-content"
                                :style="{
                                        height: storeItemActive.has(index) ? heights[index] : '0',
                                       
                                        overflow: 'hidden',
                                    }"
                            >
                                <div class="find-store__item-contact" v-html="store.store_detail.contact.replace(/\n/g, '<br>')"></div>
                                
                                <a v-if="store?.store_detail?.direction != ''" :href="store.store_detail.direction" target="_blank" rel="noopener noreferrer">
                                    Get Directions
                                </a>

                            </div>
                            </div>

                    
                </div>
                
               
            </div>
        </div>
    </div>
   
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_sizeguide.scss";
</style>

<script setup lang="ts">
 const props = defineProps({
        productName: {
            type: String,
            default: ''
        },
        productSKU: {
            type: String,
            default: ''
        },
        findStore: {
            type: Array,
            default: []
        },
 });
 const storeItemActive = ref<Set<number>>(new Set([0]));
  const heights = ref<Record<number, string>>({});
   
    const open = ref(false)
   
    const show_guide__popup = () =>{
       
        open.value = true,
        document.body.style.overflowY = 'hidden';
        setTimeout(() => {
            document.addEventListener('click', handleClickOutside);
        }, 300);
    }
    const close_guide__popup = () =>{
        open.value = false,
        document.body.style.overflowY = 'scroll';
        document.removeEventListener('click', handleClickOutside);
    }
    const popupRef = ref<HTMLElement | null>(null);
    const contentRef = ref<HTMLElement | null>(null);

    const handleClickOutside = (event: MouseEvent) => {
        if (contentRef.value && !contentRef.value.contains(event.target as Node)) {
            close_guide__popup();
        }
    };

    const calculateHeights = (index: number, expand = false) => {
        const element = document.querySelector(`#store_list${index} .find-store__item-content`) as HTMLElement;
        if (element) {
            const baseHeight = element.scrollHeight;
            heights.value[index] = expand ? `${baseHeight + 10}px` : `${baseHeight}px`;
        }
    };
   
      const showFaqItemContent = (index: number) => {
        const selectedFaqs = document.querySelector(`#store_list${index}`);
        if (selectedFaqs) {
            selectedFaqs.classList.toggle('active');
        }

        if (storeItemActive.value.has(index)) {
            storeItemActive.value.delete(index);
            heights.value[index] = '0';
        } else {
            storeItemActive.value.add(index);
            calculateHeights(index, true);
        }
    };

   
</script>